import { createContext, useContext } from 'react';

import { PendingAction } from 'entities';

import { PendingEntries, LocalPendingAction } from './utils';

interface PendingActionsContextData {
  total: number;
  pendingEntries: PendingEntries;
  decreaseCount(action: PendingAction): void;
  loading: boolean;

  refetchActions(): void;
}

export const PendingActionsContext = createContext<PendingActionsContextData>(
  {} as PendingActionsContextData,
);

export function usePendingActions(): PendingActionsContextData {
  const context = useContext(PendingActionsContext);

  if (!context.decreaseCount) {
    throw new Error('usePendingActions must be used within a PendingActionsCountProvider');
  }

  return context;
}

export function useLocalPendingEntries<Action extends LocalPendingAction>(
  action: Action,
): PendingEntries[Action]['entries'] {
  const { pendingEntries } = usePendingActions();

  return pendingEntries[action].entries;
}
